module.exports = __webpack_public_path__ + "static/media/settings_language_white.a9af8a77.svg";